// import "../js/components/header.js";
import "../js/components/dropdown-address.js";
// import "../js/components/sliders.js";
import "../js/components/vertical-tabs.js";
import "../js/components/catalog-home.js";
import "../js/components/maps-tabs.js";
// import "../js/components/form.js";

